export var ResourceSelectorMode;
(function (ResourceSelectorMode) {
    ResourceSelectorMode["RESOURCE_SELECTOR_MODE_ALL"] = "ALL";
    ResourceSelectorMode["RESOURCE_SELECTOR_MODE_NONE"] = "NONE";
    ResourceSelectorMode["RESOURCE_SELECTOR_MODE_CONDITIONAL"] = "CONDITIONAL";
})(ResourceSelectorMode || (ResourceSelectorMode = {}));
